import useSWR from "swr";
import { getAPI } from "@/lib/api";
import type { PipelineHealthData } from "./presentation";
import { readCreationDimensions } from "./creationDimensionData";

export function useCreationDimensions(data: PipelineHealthData, enabled: boolean) {
  const companyId = data.context.data?.company.id;
  return useSWR(enabled && companyId === 53 ? ["pipeline-health-crm-dimensions", companyId] : null,
    async () => readCreationDimensions(companyId!, getAPI, true),
    { revalidateOnFocus: false, revalidateOnReconnect: false, errorRetryCount: 0 });
}
